import { Col, Row } from 'antd'
import Loading from 'app/pages/PurchasingRequest/Components/Loading'
import React, { useEffect } from 'react'

import { usePurchasingRequest } from '../Hooks/usePurchasingRequest'

type PurchasingRequestLoadingProps = {
  children: React.ReactNode
}

/**
 * @note Goal of this component is to fetch the purchasing request data on page load
 * Do not add any other logic to this component.
 **/
const PurchasingRequestLoading: React.FC<PurchasingRequestLoadingProps> = ({ children }) => {
  const { fetching, fetch, destroyState } = usePurchasingRequest()

  useEffect(() => {
    fetch()
    return () => destroyState()
  }, [])

  return (
    <Row>
      {fetching ? (
        <Col span={24}>
          <Loading />
        </Col>
      ) : (
        <Col span={24}>{children}</Col>
      )}
    </Row>
  )
}

export default PurchasingRequestLoading
